<template>
  <div class="Empty-container">
    <div class="Empty" v-if="masteremptycontent">
      <div class="I-img">
        <img :src="eimg" alt="Master" />
      </div>
      <p class="E-heading mb-0 py-2">{{ eheader }}</p>
      <p class="E-content mb-0">Your {{ eheader }} List is Empty right now.</p>

      <div v-if="createline == true">
        <p class="E-content">Click below to create new one.</p>
        <div class="create pt-3" @click="$emit('createNew')">
          <span><i class="pi pi-plus plusicon"></i></span>
          <span class="E-add ps-2"> Create a new {{ econtent }} </span>
        </div>
      </div>
    </div>
    <div class="Empty" v-if="!masteremptycontent">
      <div class="I-img">
        <img :src="eimg" alt="Master" />
      </div>
      <p class="E-heading mb-0 py-2">{{ eheader }}</p>
      <p class="E-billcontent mb-0">{{ econtent }} </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";


export default defineComponent({
  components: {

  },
  props: {
    eheader: {
      type: String,
      default: "",
    },
    econtent: {
      type: String,
      default: "",
    },

    eimg: {
      type: String,
      default: "",
    },
    route: {
      type: String,
      default: "",
    },
    createline: {
      type: Boolean,
      default: true,
    },
    masteremptycontent: {
      type: Boolean,
      default: true,
    },
    // btnname: {
    //     type: String,
    //     default: 'Add New'
    // }
  },
  setup() {
    return {};
  },
});
</script>

<style lang="scss">
.Empty-container {
  background-color: #f8f9fe;
  // margin-top: 20px;
  // height: 500px;
  height: 60vh !important;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .Empty {
    .I-img {
      text-align: center;
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 50px;

      img {
        width: 50px;
      }
    }

    .E-heading {
      color: #444444;
      text-align: center;
      font-weight: 600;
      margin-bottom: 20px;
      font-weight: 12px;
      letter-spacing: 0.5px;
    }

    .E-content {
      // width: 300px;
      text-align: center;
      color: #999999;
      // letter-spacing: .5px;
      margin-bottom: 10px;
      font-size: 10px;
    }

    .E-billcontent {
      text-align: center;
      color: #999999;
      margin-bottom: 10px;
      font-size: 14px;
    }

    .create {
      cursor: pointer;
      justify-content: center;
      display: flex;
      font-weight: 500 !important;
      color: #0148e2 !important;
      font-size: 15px;

      .plusicon {
        font-size: 0.75rem !important;
      }
    }

    // align-items: center;
  }
}
</style>
